import { filter, mergeMap } from 'rxjs/operators';

import { RootEpic } from '../../store/epics';
import { loadConfig, loadConfigFail, loadConfigSuccess } from '../reducers';

const loadConfigEpic: RootEpic = (action$, _state$, { api }) => {
  return action$.pipe(
    filter(loadConfig.match),
    mergeMap(() => {
      return api.config.getConfigurations().then(loadConfigSuccess).catch(loadConfigFail);
    }),
  );
};

export { loadConfigEpic };
